<template>
  <el-dialog ref="dialog" title="发送邮件" size="large" class="ovf-hd" style="min-width:1280px">
    <div class="m-b-10 p-b-10 bor-b-ccc" v-loading="loading">
      <div class="fr m-b-10" v-show="show">
        <div class="m-b-10">选择模板</div>
        <el-select v-model="templet" filterable placeholder="请选择模板">
          <el-option 
            v-for="option in templetList"
            :label="option.title"
            :value="option">
          </el-option>
        </el-select>
      </div>
      <div class="m-b-10">
        <div class="m-b-10">标题</div>
        <el-input class="w-200" v-model="title"></el-input>
      </div>
      <div class="m-b-30">
        <div class="m-b-10">内容</div>
        <honray-editor
          id="email123456"
          :height="400"
          :uploadImgUrl="host + 'admin/upload'"
          :uploadHeaders="header"
          v-model="content"></honray-editor>
      </div>
      <div class="form-tips">以下变量标签可以直接插入到标题或内容中使用：</div>
      <div v-for="item in paramList">
        {{ item.param }}：{{ item.name }}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submit">发 送</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import http from '../../../../assets/js/http'
  import honrayEditor from '../../../Common/business/inputs/honrayEditor'
  export default {
    props: {
      source: {
        type: Object,
        default() {
          return {
            url: '',
            ids: [],
            dealId: ''
          }
        }
      }
    },
    data() {
      return {
        title: '',
        content: '',
        templet: null,
        templetList: [],
        paramList: [],
        loading: false,
        host: '',
        header: '',
        show: false
      }
    },
    created() {
      this.host = HOST
      if (this.source.dealId) {
        this.getData()
      }
    },
    methods: {
      async getData() {
        this.show = false
        let res = await this.apiGet(`cms/contents/0/getemail/${this.source.dealId}`)
        let data = this.promiseHandler(data, res)
        if (data) {
          this.templetList = data.templet
          this.paramList = data.params
          if (!_g.isRealEmpty(data.templet)) {
            this.show = true
          }
        } else {
          this.templetList = []
          this.paramList = []
        }
      },
      openDialog() {
        this.header = _g.updateHttpHeader()
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      resetData() {
        this.content = ''
        this.title = ''
        this.templet = null
      },
      submit() {
        this.send()
        this.resetData()
        this.closeDialog()
      },
      send() {
        if (!this.source.url) {
          _g.toastMsg(this, 'error', '删除失败')
          return
        }
        let ids = this.source.ids
        let postData = {
          ids: ids,
          content: this.content,
          title: this.title
        }
        this.loading = true
        this.apiPost(this.source.url, postData).then((res) => {
          if (res.code == 200) {
            this.$emit('emailCallback', true, res)
          } else {
            this.$emit('emailCallback', false, res)
            _g.dealError(this, res)
          }
          this.loading = false
        })
      }
    },
    watch: {
      'templet'() {
        if (!_g.isRealEmpty(this.templet)) {
          this.title = this.templet.title
          this.content = this.templet.content
        }
      },
      async 'source.dealId'() {
        if (this.source.dealId) {
          this.getData()
        }
      }
    },
    components: {
      honrayEditor
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// emailDeal.vue?b0d5e1fe